import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromAuth from './auth.reducer';
/**
 * Feature selector for the auth state
 */
export const getAuthState = createFeatureSelector('auth');
/**
 * Selector to get the AD user from the state
 */
export const getADUser = createSelector(getAuthState, fromAuth.getADUser);
/**
 * Selector to get the AD user id from the state
 */
export const getUserId = createSelector(getADUser, (user) => user && user.profile && user.profile.oid);
/**
 * Selector to get the login state
 */
export const getIsLoggedIn = createSelector(getAuthState, fromAuth.isLoggedIn);
/**
 * Selector to check if there is a user logging in
 */
export const getIsSettingUser = createSelector(getAuthState, fromAuth.isSettingUser);
/**
 * Selector to check if there is a user login failed
 */
export const getLoginFailed = createSelector(getAuthState, fromAuth.loginFailed);
/**
 * Selector to get the AD user from the state
 */
export const getInternalUserToken = createSelector(getADUser, (user) => user && user.profile && user.profile.permissionToken);
/**
 * Selector to get the AD user from the state
 */
export const getGraphToken = createSelector(getADUser, (user) => user && user.profile && user.profile.graphToken);
/**
 * Selector to get the login state
 */
export const getUserType = createSelector(getAuthState, fromAuth.userType);
/**
 * Selector to get the auth strategy
 */
export const getAuthenticationStrategy = createSelector(getAuthState, fromAuth.getAuthStrategy);
/**
 * Selector to get the auth status
 */
export const getIsAuthenticated = createSelector(getAuthState, fromAuth.getIsAuthenticated);
export const getAuthenticationStarted = createSelector(getAuthState, fromAuth.getAuthenticationStarted);
export const getAuthenticationEnded = createSelector(getAuthState, fromAuth.getAuthenticationEnded);
export const getOktaUserclaim = createSelector(getAuthState, fromAuth.getOktaUserclaim);
//# sourceMappingURL=auth.selectors.js.map